import styled from "styled-components";

export const LoggedOutPageContainer = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ChatLayout = styled.div`
  width: 100%;
  height 100vh;
  display: block;
  max-width: 700px;
  margin: auto;
  padding: 100px 10px 30px 10px;

  @media (min-width: 768px) {
    width: 90vw;
  }
`;
